<!-- Lamp Details -->
<template>
  <b-modal 
    v-if="currentLamp != null" 
    :visible="visible" 
    @hidden="hide" 
    @change="change" 
    scrollable
    ref="modal_lamp_details" 
    id="modal-lamp-details" 
    no-close-on-backdrop
    :title="$t('lamp_details_modal.title', { id: (currentLamp.cu_type === 'sicuro' ? currentLamp.lamp_id : currentLamp.id) })" 
    :ok-only="true" 
    :ok-title="$t('close')">

    <!-- scheda descrittiva in alto -->
    <!-- | foto | Product | id | -->
    <b-row>
      <b-col cols="12" sm="4">
        <img v-if="currentLamp.product_image != null && currentLamp.product_image != ''" class="ml-4" 
             :src="currentLamp.product_image.includes('|') ? pathDeviceImages + currentLamp.product_image.split('|')[0] : pathDeviceImages + currentLamp.product_image"
          style="height:80px; width:auto; float: left; margin-right: 10px" />
        <img v-else :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
      </b-col>
      <b-col v-if="currentLamp.product_desc && !currentLamp.product_desc.includes('|')" cols="8" offset="1"
        offset-sm="0" sm="6">
        <b-row>
          <b-col>
            {{ $t("details_lamp.lamp_prod_desc") }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>
              {{currentLamp.product_desc }}
            </strong>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="currentLamp.product_desc && currentLamp.product_desc.includes('|')" cols="8" offset="1" offset-sm="0" sm="6">
        <b-row>
          <b-col>
            {{ $t("details_lamp.lamp_prod_desc") }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>
              {{currentLamp.product_desc.split('|')[0]}}
            </strong>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="!currentLamp.product_desc" cols="8" offset="1" offset-sm="0" sm="6">
        <b-row>
          <b-col>
            {{ $t("details_lamp.lamp_prod_desc")}}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>---</strong>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3" sm="2">
        <b-row>
          <b-col>{{ $t("details_lamp.lamp_id") }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>{{currentLamp.id ? currentLamp.id : currentLamp.lamp_id }}</strong>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- | - | description | button modifica |  -->
    <b-row class="mt-2">
      <b-col cols="11" offset="1" sm="8" offset-sm="4">
        <b-row>
          <b-col>{{ $t("details_lamp.lamp_desc") }}</b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="9" sm="10"><strong>
            {{ currentLamp.desc ? currentLamp.desc : nomeLamp }}</strong>
          </b-col>       
        </b-row> -->
        <!-- {{ currentLamp.desc ? currentLamp.desc : nomeLamp }} -->
        <b-row>
          <b-col v-if="!editingLampLocal" cols="9" sm="10"><strong>
              {{ nomeLampAttuale }}</strong></b-col>
          <b-col v-if="!editingLampLocal" cols="3" sm="2"><b-button @click="editNomeLamp"><i
                class="fa fa-edit"></i></b-button></b-col>
          <b-col v-else cols="3" sm="2"></b-col>
          <b-col v-if="editingLampLocal" cols="7" sm="8">
            <div role="group">
              <b-form-input id="lampName" type="text" v-model="nomeLamp" :maxlength="maxchar"></b-form-input>
              <b-form-text v-html="lampNameInfo()"></b-form-text>
            </div>
          </b-col>
          <b-col v-if="editingLampLocal" cols="5" sm="4">
            <b-button v-if="!updatingNameLocal" @click="saveNomeLamp"><i class="fa fa-check"></i></b-button>
            <b-button v-if="!updatingNameLocal" @click="abortNomeLamp"><i class="fa fa-close"></i></b-button>
            <span v-if="updatingNameLocal"><i class="fa fa-spinner fa-spin"></i></span>
          </b-col>
        </b-row>

        <!-- pdf -->
        <b-row>
          <b-col
            v-if="currentLamp.product_pdf != null && currentLamp.product_pdf != 'undefined' && currentLamp.product_pdf != ''">
            {{ $t("details_lamp.lamp_pdf") }}</b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="currentLamp.product_pdf != null && currentLamp.product_pdf != 'undefined' && currentLamp.product_pdf != ''">
            <a :href="currentLamp.product_pdf.includes('|') ? pathDevicePdf + currentLamp.product_pdf.split('|')[0] : pathDevicePdf + currentLamp.product_pdf"
              target="_blank">
              <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
              {{ currentLamp.product_pdf.includes('|') ? currentLamp.product_pdf.split('|')[0] : currentLamp.product_pdf }}
            </a>
            <br />
            <a  v-if="currentLamp.product_pdf.includes('|') && currentLamp.product_pdf.split('|')[1]!=null" :href="pathDevicePdf + currentLamp.product_pdf.split('|')[1]"
              target="_blank">
              <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
              {{ currentLamp.product_pdf.includes("|") ? currentLamp.product_pdf.split("|")[1] : '' }}
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div v-if="currentLamp.fan_sanifica && currentLamp.fan_sanifica != '--' && currentLamp.fan_sanifica != '-'">
      <hr>
      <b-row class="m-2"><b-col sm="12"><strong>Parametri di sanificazione</strong></b-col></b-row>
      <b-row class="m-2"><b-col cols="6" sm="5">Sanificazione :</b-col><b-col cols="4" sm="4">
        {{ currentLamp.state_lampFunctionlenghtsanifica }}</b-col></b-row>
      <b-row class="m-2"><b-col cols="6" sm="5">Ventola :</b-col><b-col cols="4" sm="4">
        {{ currentLamp.fan_sanifica }}</b-col></b-row>
      <b-row class="m-2"><b-col cols="6" sm="5">Profilo :</b-col><b-col cols="4" sm="4">
        {{ currentLamp.timer_sanifica }}</b-col></b-row>
    </div>
    <!-- Parameters -->
    <div v-if="!scanning">
      <hr>
      <b-row v-if="(lampFunction(currentLamp) == 'EMERGENZA') || (lampFunction(currentLamp) == 'SICURO')"
        class="m-2"><b-col sm="12"><strong>{{ $t("details_lamp.lamp_param") }}</strong></b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_autonomy") }} :</b-col><b-col cols="6" sm="4">{{ currentLamp.autonomy }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_parity") }} :</b-col><b-col cols="6" sm="4">
      {{ $t("param_lamp." + currentLamp.parity)}}</b-col></b-row>
      <b-row class="m-2"
        v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.lssa && currentLamp.cu_type.startsWith('cablecom')">
        <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_infinity") }} :</b-col><b-col cols="6" sm="4">
          {{$t("param_lamp." + currentLamp.lssa) }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_type") }} :</b-col><b-col cols="6" sm="4">{{ currentLamp.lamp_type }}</b-col></b-row>

      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_actual_power") }} :</b-col><b-col cols="6" sm="4">
          {{(parseFloat(currentLamp.potenza_attuale).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_min_power") }} :</b-col><b-col cols="6" sm="4">
          {{(parseFloat(currentLamp.potenza_minima).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_max_power") }} :</b-col><b-col cols="6" sm="4">
          {{(parseFloat(currentLamp.potenza_massima).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_subst_power") }} :</b-col><b-col cols="6" sm="4">
          {{(parseFloat(currentLamp.potenza_sostituita).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_energy") }} :</b-col><b-col cols="6" sm="4">
          {{((parseFloat(currentLamp.energia_consumata) / 1000).toFixed(1) + " kWh") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_timeon") }} :</b-col><b-col cols="6" sm="4">
          {{(parseFloat(currentLamp.TimeOn)).toFixed(0) }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_autocalib") }} :</b-col><b-col cols="6" sm="4"> <i v-if="currentLamp.autocalib_enabled"
            class="fa fa-check" style="color:green" /><i v-else class="fa fa-close"
            style="color:gray" /></b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_autodimmer") }} :</b-col><b-col cols="6" sm="4"><i v-if="currentLamp.autodimmer_enabled"
            class="fa fa-check" style="color:green" /><i v-else class="fa fa-close"
            style="color:gray" /></b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_opticom") }} :</b-col><b-col cols="6" sm="4"><i v-if="currentLamp.opticom"
            class="fa fa-check" style="color:green" /><i v-else class="fa fa-close"
            style="color:gray" /></b-col></b-row>

      <b-row v-if="(lampFunction(currentLamp) == 'SICURO')" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_function") }} :</b-col> 
        <b-col cols="6" sm="4">
          {{ currentLamp.device_function}}</b-col>
        </b-row>
      <b-row v-if="(lampFunction(currentLamp) == 'SICURO')" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_type") }} :</b-col> <b-col cols="6" sm="4">{{ currentLamp.device_type }}</b-col></b-row>
      <b-row v-if="(lampFunction(currentLamp) == 'SICURO')" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_dimming") }} :</b-col> <b-col cols="6" sm="4">{{ currentLamp.dimming }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{    $t("details_lamp.lamp_actual_power") }} :</b-col>
        <b-col cols="6" sm="4">{{ currentLamp.istantaneousPower + "W" }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_min_power") }} :</b-col><b-col cols="6" sm="4">
        {{(parseFloat(currentLamp.minPower).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_max_power") }} :</b-col><b-col cols="6" sm="4">
        {{(parseFloat(currentLamp.maxPower).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_subst_power") }} :</b-col><b-col cols="6" sm="4">    
        {{(parseFloat(currentLamp.powerReplaced).toFixed(1) + " W") }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_energy") }} :</b-col><b-col cols="6" sm="4">
          {{ currentLamp.energy + "Wh"}}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("energy.energy_saved") }} :</b-col><b-col cols="6" sm="4">
          {{ currentLamp.energySaved + "Wh  (" + parseFloat(currentLamp.energySaved*100/(currentLamp.energy+currentLamp.energySaved)).toFixed(1) + "%)"}}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_timeon") }} :</b-col><b-col cols="6" sm="4">
          {{ currentLamp.functionHours}}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.input_group") }} :</b-col><b-col cols="6" sm="4">
          {{ currentLamp.group}}</b-col></b-row>        
        
      <hr>

      <!-- Details -->
      <b-row class="m-2"><b-col sm="12"><strong>{{ $t("details_lamp.lamp_details") }}</strong></b-col></b-row>
      <b-row
        v-if="currentLamp.product_code != 'undefined' && currentLamp.product_code != null && !currentLamp.product_desc.includes('|')"
        class="m-2"><b-col cols="6" sm="5">{{ $t("details_lamp.lamp_code") }} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.product_code }}</b-col></b-row>
      <b-row
        v-if="currentLamp.product_code != 'undefined' && currentLamp.product_code != null && currentLamp.product_desc.includes('|')"
        class="m-2"><b-col cols="6" sm="5">{{ $t("details_lamp.lamp_code") }} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.product_code.split('|')[0] }}</b-col></b-row>
      <b-row v-if="currentLamp.order_code != 'undefined' && currentLamp.order_code != null" class="m-2"><b-col cols="6"
          sm="5">{{ $t("details_lamp.lamp_order_code") }} :</b-col><b-col cols="6" sm="4">
            {{ currentLamp.order_code}}</b-col></b-row>
      <b-row
        v-if="lampFunction(currentLamp).includes('EMERGENZA') && currentLamp.battery_desc != 'undefined' && currentLamp.battery_desc != null && currentLamp.battery_desc.includes('/') == true && !currentLamp.battery_desc.includes('|')"
        class="m-2">
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_desc") }} 1 :</b-col><b-col cols="6" sm="4">
          {{currentLamp.battery_desc.split('/')[0] }}</b-col>
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_desc") }} 2 :</b-col><b-col cols="6" sm="4">
          {{currentLamp.battery_desc.split('/')[1] }}</b-col>
      </b-row>
      <b-row
      v-if="lampFunction(currentLamp).includes('EMERGENZA') &&  currentLamp.battery_desc != 'undefined' && currentLamp.battery_desc != null && !currentLamp.battery_desc.includes('/') == true && currentLamp.battery_desc.includes('|')"
      class="m-2">
      <b-col cols="6" sm="5">{{ $t("details_lamp.battery_desc") }} :</b-col><b-col cols="6" sm="4">
        {{currentLamp.battery_desc.split('|')[0] }}</b-col>
    </b-row>
      <b-row
        v-if="lampFunction(currentLamp).includes('EMERGENZA') && currentLamp.battery_desc != 'undefined' && currentLamp.battery_desc != null && currentLamp.battery_desc.includes('/') == false && !currentLamp.battery_desc.includes('|')"
        class="m-2">
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_desc") }} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.battery_desc }}</b-col>
      </b-row>
      <b-row
        v-if="lampFunction(currentLamp).includes('EMERGENZA') && currentLamp.battery_code != 'undefined' && currentLamp.battery_code != null && currentLamp.battery_code.includes('/') == true"
        class="m-2">
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_code") }} 1 :</b-col><b-col cols="6" sm="4">
          {{currentLamp.battery_code.split('/')[0] }}</b-col>
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_code") }} 2 :</b-col><b-col cols="6" sm="4">
          {{currentLamp.battery_code.split('/')[1] }}</b-col>
      </b-row>
      <b-row
        v-if="lampFunction(currentLamp).includes('EMERGENZA') && currentLamp.battery_code != 'undefined' && currentLamp.battery_code != null && currentLamp.battery_code.includes('/') == false"
        class="m-2">
        <b-col cols="6" sm="5">{{ $t("details_lamp.battery_code") }} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.product_desc.includes('|')? currentLamp.battery_code.split('|')[0]: currentLamp.battery_code}}</b-col>
      </b-row>
      <b-row v-if="currentLamp.tube_desc != 'undefined' && currentLamp.tube_desc != null" class="m-2"> <b-col cols="6"
          sm="5">{{ $t("details_lamp.tube_desc") }} :</b-col><b-col cols="6" sm="4">
            {{ currentLamp.tube_desc}}</b-col></b-row>
      <b-row v-if="currentLamp.tube_code != 'undefined' && currentLamp.tube_code != null" class="m-2"><b-col cols="6"
          sm="5">{{ $t("details_lamp.tube_code") }} :</b-col><b-col cols="6" sm="4">
            {{ currentLamp.tube_code}}</b-col></b-row>
      <b-row
        v-if="currentLamp.uvoxy_desc != 'undefined' && currentLamp.uvoxy_desc != null && currentLamp.uvoxy_desc != ''"
        class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.uvoxy_desc")}} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.uvoxy_desc }}</b-col></b-row>
      <b-row
        v-if="currentLamp.uvoxy_code != 'undefined' && currentLamp.uvoxy_code != null && currentLamp.uvoxy_code != ''"
        class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.uvoxy_code")}} :</b-col><b-col cols="6" sm="4">
          {{currentLamp.uvoxy_code }}</b-col></b-row>
      <b-row
        v-if="currentLamp.lamp_apparech_type && currentLamp.lamp_apparech_type != null && currentLamp.lamp_apparech_type != ''"
        class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.device_type")}} :</b-col><b-col cols="6" sm="4">
          {{parseInt(currentLamp.lamp_apparech_type, 16)}}</b-col></b-row>
      <b-row v-if="currentLamp.node_type != null" class="m-2"> <b-col cols="6" sm="5">{{ $t("details_lamp.node_type") }}
          :</b-col><b-col cols="6" sm="7">{{currentLamp.node_type}}</b-col></b-row>
      <b-row v-if="currentLamp.lamp_location != null" class="m-2"><b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_location")}} :</b-col><b-col cols="6" sm="7">{{currentLamp.lamp_location}}</b-col></b-row>
      <b-row v-if="currentLamp.nodo_orfano != null" class="m-2"><b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_orphan")}}
          :</b-col><b-col cols="6" sm="7">
          <span v-if="!currentLamp.nodo_orfano && currentLamp.nodo_orfano != null"><i class="fa fa-x2 fa-rss mr-2"
              style="color:green"></i></span>
          <span v-if="currentLamp.nodo_orfano && currentLamp.nodo_orfano != null">
            <b-iconstack font-scale="1.5">
              <b-icon stacked icon="wifi" style="color: violet;" scale="1"></b-icon>
              <b-icon stacked icon="slash" style="color: violet;" ></b-icon>      
          </b-iconstack>
          </span>
        </b-col></b-row>
      <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_sw")}} :</b-col>
      <b-col cols="6" sm="4">{{currentLamp.sw_ver}} 
        <span v-if="currentLamp.sw_build && currentLamp.sw_build != 'nd'">(build: {{currentLamp.sw_build}})</span>
      </b-col>
      </b-row>
      
      <b-row v-if="currentLamp.cloudCode!=null" class="m-2"> 
        <b-col cols="6" sm="5">Cloud code :</b-col>
        <b-col cols="6" sm="4">{{currentLamp.cloudCode}} </b-col>
      </b-row>

      <b-row v-if="currentLamp.mac_address!=null" class="m-2"> 
        <b-col cols="6" sm="5">Mac address :</b-col>
        <b-col cols="6" sm="4">{{currentLamp.mac_address}} </b-col>
      </b-row>

      <!-- Status -->
      <hr v-if="lampFunction(currentLamp) == 'EMERGENZA' || lampFunction(currentLamp) == 'ILLUMINAZIONE'">
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA' || lampFunction(currentLamp) == 'ILLUMINAZIONE'"
        class="m-2"><b-col sm="12"><strong>{{ $t("details_lamp.lamp_state") }}</strong></b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.battery_state != ''" class="m-2"> 
        <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_battery_state") }} :</b-col><b-col cols="6" sm="7">
            {{$t("param_lamp." + currentLamp.battery_state) }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.test_duration != ''" class="m-2"> 
        <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_test_duration") }} :</b-col>
        <b-col cols="6" sm="7">
            {{currentLamp.test_duration }}
        </b-col>
      </b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.emer_active != ''" class="m-2"> 
        <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_se") }} :</b-col><b-col cols="6" sm="4">
          {{ $t("param_lamp." + currentLamp.emer_active) }}</b-col></b-row>
      <b-row
        v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.lamp_type != 'SE' && currentLamp.sa_presence != ''"
        class="m-2"> <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_sa") }} :</b-col><b-col cols="6" sm="4">
          {{(currentLamp.sa_presence==true || currentLamp.sa_presence.toString()=='SA PRESENTE')?
              $t("present"):$t("absent")}}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA' && currentLamp.lamp_type != 'SE'" class="m-2">
        <b-col cols="6" sm="5">{{ $t("details_lamp.lamp_sa_dimming") }}: </b-col>
        <b-col v-if='currentLamp.cu_type == "bluetooth" && currentLamp.sa_dimming == "SE"' cols="6" sm="7">
        {{$t("param_lamp." + currentLamp.sa_dimming) }}</b-col>
        <b-col v-if='currentLamp.cu_type == "bluetooth" && currentLamp.sa_dimming != "SE"' cols="6" sm="7">
        {{$t("param_lamp." + currentLamp.device_function) }}</b-col>
        <b-col v-if='currentLamp.cu_type != "bluetooth"' cols="6" sm="7">
        {{ $t("param_lamp." + currentLamp.sa_dimming)}}</b-col>
      </b-row>
      <b-row v-if="lampFunction(currentLamp) == 'EMERGENZA'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.lamp_test_active") }} :</b-col>
        <b-col cols="6" sm="7">{{ $t("param_lamp." + currentLamp.test_active) }}</b-col></b-row>
      <b-row v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE'" class="m-2"> <b-col cols="6" sm="5">
        {{$t("details_lamp.stato_nodo") }} :</b-col><b-col cols="6" sm="7">{{ currentLamp.stato_nodo }}</b-col></b-row>
      <!-- Groups -->
      <hr v-if="currentLamp.groups">
      <b-row v-if="currentLamp.groups" class="m-2">
        <b-col sm="12"><strong>{{ $t("details_lamp.groups") }}</strong></b-col>
        <b-col v-if="currentLamp.groups.length == 0" sm="12"><span>{{ $t("details_lamp.groups_none") }}</span></b-col>
        <b-col v-else sm="12">
          <span v-for="(group, index) in currentLamp.groups" :key="index">
            <span class="h6">{{ group }}</span><span v-if="index < currentLamp.groups.length - 1"> - </span>
          </span>
        </b-col>
      </b-row>

      <LampBleConfigDetails v-if="lampFunction(currentLamp) == 'ILLUMINAZIONE-BLE'" :currentLamp="currentLamp"></LampBleConfigDetails>
      
      <!-- Errors found -->
      <hr
        v-if="lampFunction(currentLamp) == 'EMERGENZA' || lampFunction(currentLamp) == 'ILLUMINAZIONE' || lampFunction(currentLamp) == 'SICURO'">
      <b-row class="m-2"><b-col sm="12"><strong>{{ $t("details_lamp.lamp_error") }}</strong></b-col></b-row>

      <!-- errore hw generico sia per lamapde di emergenza che di illuminazione -->
      <b-row class="m-2" v-if='currentLamp.error_hardware == "ON" && currentLamp.error_com == "OFF" &&  currentLamp.error_comm_radio_lamp == "OFF"'><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:red"></i>
            {{ $t("details_lamp.lamp_error_hardware")}}</b-col></b-row>

      <!-- errori su lampade di emergenza -->
      <b-row class="m-2" v-if='currentLamp.error_batt_short == "ON"'><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:red"></i>
            {{ $t("details_lamp.lamp_error_batt_short")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_batt_test == "ON"'><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:red"></i>
            {{ $t("details_lamp.lamp_error_batt_test")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_batt_test_auto && currentLamp.error_batt_test_auto == "ON"'><b-col
          sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
          {{$t("details_lamp.lamp_error_batt_test_auto") }}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_batt_test_auto && currentLamp.error_batt_test_auto == "ON" && currentLamp.error_ric_incompleta'><b-col
          sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>
          {{$t("details_lamp.lamp_error_ric_incompleta") }}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_tubo_UV && currentLamp.error_tubo_UV == "ON"'><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:blue"></i>
            {{ $t("details_lamp.lamp_error_tubo_UV")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_com == "ON" && currentLamp.error_hardware == "OFF"'><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:orange"></i>
            {{ $t("details_lamp.lamp_error_com")}}</b-col></b-row>
      <b-row class="m-2" v-if='(currentLamp.error_com == "ON" && currentLamp.error_hardware == "ON") || currentLamp.error_comm_radio_lamp == "ON" '><b-col sm="12"><i
            class="fa fa-exclamation-circle mr-2" style="color:red"></i>
            {{ $t("details_lamp.lamp_error_comm_radio_lamp")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_led == "ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2"
            style="color:red"></i>{{ $t("details_lamp.lamp_error_led") }}</b-col></b-row>

      <!-- errori su lampade di illuminazione -->
      <b-row class="m-2" v-if='currentLamp.error_overpower == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_overpower")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_overvoltage == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_overvoltage")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_underpower == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_underpower")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_undervoltage == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_undervoltage")}}</b-col></b-row>

      <!-- errori su lampade di illuminazione -->
      <b-row class="m-2" v-if='currentLamp.errorBallastCom == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_ballast_com")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.lampFail == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_fail") }}</b-col></b-row>

      <!-- errore per nodo orfano -->
      <b-row class="m-2" v-if='currentLamp.cu_type == "logicafm" && currentLamp.nodo_orfano == true'><b-col sm="12">
        <b-iconstack font-scale="1.5">
          <b-icon stacked icon="wifi" style="color: violet;" scale="1"></b-icon>
          <b-icon stacked icon="slash" style="color: violet;" ></b-icon>      
        </b-iconstack>
        {{ $t("details_lamp.lamp_orphan_error")}}</b-col></b-row>

      <!-- errori lampade Sicuro -->
      <b-row class="m-2" v-if="currentLamp.error_com_cpu_ak == 'ON'"><b-col sm="12">
        <b-iconstack font-scale="1.5">
                  <b-icon stacked icon="slash" style="color:red"></b-icon>
                  <b-icon stacked icon="arrow-left-right" style="color:red"></b-icon>
        </b-iconstack>
        {{ $t("details_cu_modal.cu_error_com_cpu_AK")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_com_ak_lamp == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>
        {{ $t("details_lamp.lamp_error_com_ak_lamp")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_dali_com == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_dali_com")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_dali_hardware == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.error_dali_hardware")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_dali_lamp == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_dali_lamp")}}</b-col></b-row> 
      <b-row class="m-2" v-if='currentLamp.error_id_duplicate == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_duplicate")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_led_full_short == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_led_full_short")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_led_open == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_led_open")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_led_partial_short == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{$t("details_lamp.lamp_error_led_partial_short") }}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_line_fuse == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_line_fuse")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_low_voltage == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_low_voltage")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_lamp_programming == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{ $t("details_lamp.lamp_error_programming")}}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_reverse_polarity == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{$t("details_lamp.lamp_error_reverse_polarity") }}</b-col></b-row>
      <b-row class="m-2" v-if='currentLamp.error_under_threshold == "ON"'><b-col sm="12">
        <i class="fa fa-exclamation-circle mr-2" style="color:red"></i>
        {{$t("details_lamp.lamp_error_cunder_threshold") }}</b-col></b-row>

      <!-- gestione nessun errore lampade sicuro -->
      <b-row class="m-2" v-if='currentLamp.cu_type == "sicuro" && calcolaNumErrori(currentLamp) == 0'>
        <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>
        {{$t("details_cu_modal.cu_no_error") }}</b-col>
      </b-row>
      <!-- gestione nessun errore su lampade di emergenza -->
      <b-row class="m-2" v-if='lampFunction(currentLamp) == "EMERGENZA"
          && currentLamp.error_batt_short == "OFF"
          && currentLamp.error_batt_test == "OFF"
          && (!currentLamp.error_batt_test_auto || currentLamp.error_batt_test_auto == "OFF")
          && (!currentLamp.error_tubo_UV || currentLamp.error_tubo_UV == "OFF")
          && currentLamp.error_com == "OFF"
          && (!currentLamp.error_comm_radio_lamp || currentLamp.error_comm_radio_lamp == "OFF")
          && currentLamp.error_led == "OFF"
          && currentLamp.error_hardware == "OFF"
          && (!currentLamp.nodo_orfano || currentLamp.nodo_orfano == false)'>
        <b-col sm="12"><i class="fa fa-check mr-2" style="color:green"></i>
        {{ $t("details_lamp.lamp_no_error")}}</b-col>
      </b-row>

      <!-- gestione nessun errore su lampade di illuminazione -->
      <b-row class="m-2" v-if='lampFunction(currentLamp) == "ILLUMINAZIONE"
          && currentLamp.error_overpower == "OFF"
          && currentLamp.error_overvoltage == "OFF"
          && currentLamp.error_underpower == "OFF"
          && currentLamp.error_undervoltage == "OFF"
          && currentLamp.error_com == "OFF"
          && currentLamp.error_comm_radio_lamp == "OFF"
          && currentLamp.error_hardware == "OFF"
          && currentLamp.nodo_orfano == false'>
        <b-col sm="12"><i class="fa fa-check mr-2" style="color:green"></i>
        {{ $t("details_lamp.lamp_no_error")}}</b-col>
      </b-row>

      <!-- gestione nessun errore su lampade di illuminazione ble -->
      <b-row class="m-2" v-if='lampFunction(currentLamp) == "ILLUMINAZIONE-BLE"
          && currentLamp.errorBallastCom == "OFF"
          && currentLamp.error_com == "OFF"
          && currentLamp.lampFail == "OFF"'>
        <b-col sm="12"><i class="fa fa-check mr-2" style="color:green"></i>
        {{ $t("details_lamp.lamp_no_error")}}</b-col>
      </b-row>

      <!-- gestione nessun errore su sensori -->
      <b-row class="m-2" v-if='lampFunction(currentLamp) == "SENSORI"
          && currentLamp.nodo_orfano == false'>
        <b-col sm="12"><i class="fa fa-check mr-2" style="color:green"></i>
        {{ $t("details_lamp.lamp_no_error")}}</b-col>
      </b-row>

    </div>

  </b-modal>
</template>

<script>
// import Vue from 'vue'

import { mapState } from 'vuex';
import LampBleConfigDetails from '@/components/SDBLampDetails/LampBleConfigDetails.vue';

export default {
  name: "LampDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentCent: null,
    currentLamp: null,
    scanning: false,
    visible: {
      type: Boolean,
      default: false
    },
    // updateFinito: true,
    // editingLamp: false,
    sendAction: null
  },
  components:{
    LampBleConfigDetails
  },

  emits: ['hide', 'change', 'updating', 'editing', 'nameUpdated'],

  data()
  {
    return {
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
      pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                        //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
      isVisible: false, //*
      nomeLamp: this.currentLamp ? this.currentLamp.desc : "",
      // editingLampLocal: this.editingLamp,
      maxchar: 30,
      updatingNameLocal: false,
      editingLampLocal: false,
    };
  },

  computed: {
    ...mapState(['commandResponse']),

    nomeLampAttuale()
    {
      return this.currentLamp.desc;
    },

    // updatingNameLocal()
    // {
    //   return !this.updateFinito;
    // },
    // editingLampLocal: {
    //   get: function() {
    //     return this.editingLamp;
    //   },
    //   set: function(value) {
    //     this.$emit('editing', value);
    //   }
    // },


  },

  created()
  {
    console.log("LampDetails created")
  },
  mounted()
  {
    console.log("LampDetails mounted");
    console.log("LampDetails di ", this.currentCent);
  },
  watch: {
    commandResponse(val)
    {
      console.log("cambiata commandResponse Modal ->", val);
      //non tutti i commandResponse contengono un campo 'commandInfo', quindi devo verificare se esista
      //da rivedere perché di norma si dovrebbe verificare val.command == 'LAMP_DESC_UPDATED' o qualcosa di simile,
      //mentre commandInfo resta quando c'è un errore, in questo caso, 'OPCODE_NOT_MANAGED'
      //SINTESI: val.command vale per tutte le centrali esclusa Sicuro che utilizza commandInfo
      if((val.commandInfo && val.commandInfo.command?.command == 'setLampDesc') || (val.command && val.command == 'savedLampDescription'))
      {
        if(this.currentLamp != null) {
          this.updatingNameLocal = false;
          this.editingLampLocal = false;
          if (val.error != "") {            
            this.nomeLamp = this.currentLamp.desc;
          } else {
            this.$emit('nameUpdated', this.nomeLamp);
          }
        }
      }
    }
  },

  methods: {
    //calcola il numero di errori in un dispositivo SICURO
    calcolaNumErrori(disp)
    {
      let num = 0;
      for (const property in disp)
      {
        if ((property.includes("error")) && (disp[property] === "ON"))
        {
          num++;
        }
      }
      return num;
    },
    //restituisce un messaggio html con i caratteri introdotti
    lampNameInfo()
    {
      const nl = this.nomeLamp.length;
      //const validChars = /^[\x20-\x7F]*$/.test(this.nomeLamp);
      const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeLamp);
      if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
      if (nl > 30 || !validChars)
      {
        return "<b style=\"color:red\">" + nl + "/30 Caratteri</b>";
      }
      return "" + nl + "/30 Caratteri";
    },
    //salva il nome della lampada
    saveNomeLamp()
    {
      console.log("Provo a salvare il nome della lampada", this.currentLamp);
      //const validChars = /^[\x20-\x7F]*$/.test(this.nomeLamp);
      const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeCent);
      if (!validChars)
      {
        console.log("Invalid chars");
        this.$bvModal.msgBoxOk("La descrizione della lampada non può contenere caratteri speciali e lettere accentate");
        return;
      }

      if (this.nomeLamp.length > 30)
      {
        console.log("Troppo lunga");
        this.$bvModal.msgBoxOk("La descrizione della lampada non può superare i 30 caratteri");
        return;
      }
      if (this.currentLamp.cu_type == "sicuro") {
        var params = {};
        params.command = "setLampDesc";
        params.cu_type = this.currentLamp.cu_type;
        params.cu_id = this.currentLamp.cu_id.split('#')[1];
        params.lamps = [];
        params.num_lamps = 1;
        params.lamps[0] = { id: this.currentLamp.idx, name: this.nomeLamp };
        this.sendAction(params);        
      } else {     
        var tempLampDescInfos
        if(this.currentLamp.cu_type=="bluetooth") {
          tempLampDescInfos = { cu_type: this.currentLamp.cu_type, cu_id: this.currentLamp.cu_id, lamp_id: this.currentLamp.lamp_id, lamp_desc: this.nomeLamp };
        }        
        else {
          tempLampDescInfos = { cu_type: this.currentLamp.cu_type, cu_id: this.currentLamp.cu_id.split('#')[1], lamp_id: this.currentLamp.lamp_id, lamp_desc: this.nomeLamp };
        }

        this.$store.dispatch("dbSaveLampDescription", tempLampDescInfos);
      }

      //this.$emit('updating');
      this.updatingNameLocal = true;
    },
    //definisce la classe CSS a seconda che sia o meno in attesa di una shadow
    shadowPendingClass(value)
    {
      var pending = (value >= 0) ? "shadow-pending-true" : "shadow-pending-false"
      return pending
    },
    //interrompe la scrittura del nome della lampada (desc)
    abortNomeLamp()
    {
      this.editingLampLocal = false;
    },
    //scrive il nome della lampada (desc)
    editNomeLamp()
    {
      if (this.currentLamp.desc != null) {
        this.nomeLamp = this.currentLamp.desc;
      }
      else {
        this.nomeLamp = "";
      }
      
      this.editingLampLocal = true;
    },
    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible)
    {
      // console.log("MASSI01: change visible", visible)
      this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide()
    {
      // console.log("MASSI02: emesso hide")
      this.editingLampLocal = false;
      this.$emit("hide");
    },
    //restituisce EMERGENZA  o ILLUMINAZIONE o SICURO
    lampFunction(lamp)
    {
      if (lamp.cu_type == "bluetooth")
      {
        if (lamp.model != "9")
          return "EMERGENZA"
        else
          return "ILLUMINAZIONE-BLE"
      }
      else
      {
        if (lamp.cu_type == "sicuro")
          return "SICURO"
        else
          return (lamp.device_function || "EMERGENZA").toUpperCase();
      }
    },
  }
}
</script>

<style lang="scss">
li {
  list-style: none;
}

#tab_advanced .nav-tabs {
  font-weight: bold;
}

.typo-data {
  font-weight: 400;
  font-family: Roboto;
  font-size: 13px;
}
</style>